export const FILE_SIZE_LIMIT = 1024 * 1024 * 15; // Bytes * kBytes = 1MB * 15 = 15MBytes
export const UPLOADS_SIZE_LIMIT_FOR_PROCESS_DOCUMENT = 1024 * 1024 * 25; // 25 MB
export const UPLOAD_LIMITS = {
  files: 1,
  fields: 10,
  fileSize: FILE_SIZE_LIMIT,
};
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/bmp',
  'image/apng',
];

export const ALLOWED_FILES_IN_CHAT = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/bmp',
  'image/apng',
  'zip',
  'application/zip',
  'application/vnd.zip',
  'application/x-zip',
  'application/x-zip-compressed',
  'application/vnd.rar',
  'application/x-rar',
  'application/x-rar-compressed',
  'application/msword', // DOC
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
  'application/vnd.ms-excel', // XLS
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
];
